export interface UserTypeOption {
    text: string
    value: string
    description?: string
}

export interface AccessOption {
    text: string
    value: string
}

export interface UserManagementConfig {
    actionType?: string
    componentTitle?: string
    nextLabel?: string
    backLabel?: string
    submitLabel?: string
    cancelLabel?: string
    requiredErrorText?: string
    userType?: {
        tabLabel?: string
        heading?: string
        types?: UserTypeOption[]
        accessOptions?: AccessOption[]
        roleFieldLabel?: string
        roles?: UserTypeOption[]
        validation?: {
            userType?: string
        }
    }
    userInformation?: {
        tabLabel?: string
        gaShieldLabel?: string
        firstNameLabel?: string
        lastNameLabel?: string
        functionLabel?: string
        emailLabel?: string
        validation?: {
            firstName?: string
            lastName?: string
            function?: string
            emailEmpty?: string
            emailFormat?: string
            emailExists?: string
        }
    }
    assignAccounts?: {
        tabLabel?: string
        heading?: string
        multiAccountLabel?: string
        accountsLabel?: string
        accountsPlaceholder?: string
        userRoleLabel?: string
        userRolePlaceholder?: string
        productLabel?: string
        productPlaceholder?: string
        validation?: {
            role?: string
            product?: string
            noAssignments?: string
        }
    }
    roleExplanation?: {
        tooltipTitle?: string
        overlayTitle?: string
        configJson?: string
    }
    confirmation?: {
        successTitle?: string
        successDescription?: string
        errorTitle?: string
        errorDescription?: string
        successRedirectPath?: string
        cancelRedirectPath?: string
    }
}

export interface UserManagementProps {
    configJson?: string
    'config-json'?: string
    actionType?: string
    'action-type'?: string
    componentTitle?: string
    'component-title'?: string
    cancelRedirectPath?: string
    'cancel-redirect-path'?: string
}

function decodeHtmlEntities(str: string): string {
    const textarea = document.createElement('textarea')
    textarea.innerHTML = str
    return textarea.value
}

export function parseConfig(raw: string): UserManagementConfig {
    if (!raw) return {}
    try {
        return (JSON.parse(decodeHtmlEntities(raw)) as UserManagementConfig) ?? {}
    } catch {
        return {}
    }
}
